export * from './tabs-demo.component';
